module.exports = function() {
  return new Worker(__webpack_public_path__ + "9d1ffc8a163eb5c101a2.worker.js");
};